import { all, call } from 'redux-saga/effects';

import { clinicalTrialAffiliatesSaga } from './clinicalTrialAffiliates/clinicalTrialAffiliates.saga';
import { clinicalTrialContextSaga } from './clinicalTrialContext/clinicalTrialContext.saga';
import { authSaga } from './auth/auth.saga';
import { breadcrumbsSaga } from './breadcrumbs/breadcrumbs.saga';
import { initRpc } from 'src/services/rpc/initRpc';

const allSagas = [
  authSaga,
  breadcrumbsSaga,
  clinicalTrialContextSaga,
  clinicalTrialAffiliatesSaga,
];

export function* appSagas() {
  // Store injection starts this saga while `store.ts` is still evaluating, and
  // `initRpc` reads that store. Yielding a resolved promise defers it by one
  // microtask — enough for the module and the slices it imports to finish.
  // `initRpc` itself is synchronous.
  yield Promise.resolve();
  yield call(initRpc);

  yield all(allSagas.map(f => f()));
}
